"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fonts = {};
exports.default = fonts;
//# sourceMappingURL=fonts.js.map